import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { resetpassword } from 'src/app/models/auth/_models/resetpassword';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { RememberPasswordService } from 'src/app/services/remember-password.service';
import { MessagesService, SpinnerService } from 'src/app/services/service.index';
enum ErrorStates {
  NotSubmitted,
  HasError,
  NoError,
}
@Component({
  selector: 'remember-user',
  templateUrl: './remember-user.component.html',
  styleUrls: ['../login/login.component.scss'],
})
export class RememberUserComponent implements OnInit {
  @Output() eventRemember = new EventEmitter<any>();
  @Input() token: any = null;
  @Input() tokenvalidate: any = null;
  @Input() email: any = null;
  @Input() ambiente: any;
  showPassword: boolean = false;
  passwordConditions: {
    length: boolean;
    specialChars: boolean;
    uppercase: boolean;
    numbers: boolean;
    notRepeated: boolean;
  } = {
    length: false,
    specialChars: false,
    uppercase: false,
    numbers: false,
    notRepeated: true // Simulado como true inicialmente
  };
  s
  errorState: ErrorStates = ErrorStates.NotSubmitted;
  loginForm: FormGroup;
  // resetPasword: FormGroup;
  private unsubscribe: Subscription[] = [];
  par_case: any;
  par_ccln: any;
  par_infa: any;
  par_nmax: any;
  par_nmin: any;
  link: string;
  showSuccess: boolean;
  showError: boolean;
  numeros: any ="0123456789";
  letras: any="abcdefghyjklmnñopqrstuvwxyz";
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private rememberPasswordService: RememberPasswordService,
    private messagesService: MessagesService,
    private authService: AuthService,
    private _spinnerService: SpinnerService,
    private _route: ActivatedRoute,
  ) {
    this.loginForm = this.formBuilder.group({
      usuario: new FormControl('', [Validators.required]),
    });

   


    // this.resetPasword.get('password')?.valueChanges.subscribe(value => {
    //   this.checkPasswordConditions(value);
    // });
  }
  resetPasword = this.formBuilder.group({
    passNew: [''],
    passRepeat: [''],
  });
  async ngOnInit(): Promise<void> {

    if (!!this.token) {
      this._spinnerService.loading();
      this.Getdatainsta();
      this.token = true;
      setTimeout(() => {

        this.resetPasword = this.formBuilder.group({
          passNew: ['', [
            Validators.required,
            Validators.minLength(this.par_nmin),
            Validators.maxLength(this.par_nmax),
          ]],
          passRepeat: ['', Validators.required],
        });
        this._spinnerService.close();
      }, 1000);
    
  
    }
    else {
      this.token = false;
    }

  }

  Getdatainsta() {

    this.authService.Getdatainsta().subscribe(resp => {
      if (resp.isSuccessful) {
       this.par_case =  resp.result.paR_CASE;
       this.par_ccln =  resp.result.paR_CCLN;
       this.par_infa =  resp.result.paR_INFA;
       this.par_nmax =  resp.result.paR_NMAX;
       this.par_nmin =  resp.result.paR_NMIN;

      //  this.initForm();
        
      }
      else {

      }
    });
  }

  get usuario() {
    return this.loginForm.get('usuario');
  }
  get passNew() {
    return this.resetPasword.get('passNew');
  }

  get passRepeat() {
    return this.resetPasword.get('passRepeat');
  }
  back() {
    if (!this.token) {

      this.eventRemember.emit({ back: true });
    } else if (this.token) {
      localStorage.clear();

      // Remueve los parámetros de la URL antes de recargar
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
  
      window.location.reload();
    }
  }



  tiene_numeros(texto){
    for(let i=0; i < texto.length; i++){
       if (this.numeros.indexOf(texto.charAt(i),0)!=-1){
          return 1;
       }
    }
    return 0;
 }

 tiene_letras(texto){
  texto = texto.toLowerCase();
  for(let i=0; i<texto.length; i++){
     if (this.letras.indexOf(texto.charAt(i),0)!=-1){
        return 1;
     }
  }
  return 0;
}


  resetPassword ()  {

    if(this.par_ccln=="S"){

      let letr = this.tiene_letras(this.passNew?.value);
      let num = this.tiene_numeros(this.passNew?.value);

      if(letr==1 && num==1){
        this.showError = this.showSuccess = false;
        // const resetPass = { ...resetPasswordFormValue };
        // if (resetPass.password != resetPass.confirm) {
        //   this.messagesService.error("Las contraseñas no coinciden");
        //   return;
        // }

        // nueva: this.passNew?.value,
        //     confirma: this.passRepeat?.value,
     
          const resetPassDto: resetpassword = {
            password: this.passNew?.value,
            confirmPassword:  this.passRepeat?.value,
            token: this.tokenvalidate,
            email: this.email
          }   
          this.authService.resetPassword(resetPassDto).subscribe((result) => {
            this.showSuccess = true;
            if (result.isSuccessful) {
              this.link = 'Haga clic aquí para ingresar.';
              this.messagesService.success("Seven ERP","Tu contraseña ha sido restablecida");
              this.errorState = ErrorStates.NoError;
            }
            else {
              this.messagesService.error("Seven ERP","Erro al actualizar la contraseña");
            }
          
          })
      }
      else{
        this.messagesService.error("Seven ERP","La contraseña debe contener números y letras");
      }
    }
    else{
      this.showError = this.showSuccess = false;
      // const resetPass = { ...resetPasswordFormValue };
      // if (resetPass.password != resetPass.confirm) {
      //   this.messagesService.error("Seven ERP","Las contraseñas no coinciden");
      //   return;
      // }
   
        const resetPassDto: resetpassword = {
          password: this.passNew?.value,
          confirmPassword:  this.passRepeat?.value,
          token: this.tokenvalidate,
          email: this.email
        }   
        this.authService.resetPassword(resetPassDto).subscribe((result) => {
  
          this.showSuccess = true;
          if (result.isSuccessful) {
            this.link = 'Haga clic aquí para ingresar.';
            this.messagesService.success("Seven ERP","Tu contraseña ha sido restablecida");
            this.errorState = ErrorStates.NoError;
          }
          else {
            this.messagesService.error("Seven ERP","Erro al actualizar la contraseña");
          }
        
        })
    }

  }


  remember(action: string = 'password') {
    this._spinnerService.loading();
    let EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (this.usuario.value.match(EMAIL_REGEX)){
      this.errorState = ErrorStates.NotSubmitted;
      const forgotPasswordSubscr = this.authService
        .forgotPassword(this.usuario.value)
        .subscribe((result) => {
  
          if (result.isSuccessful==true){
            this._spinnerService.close();
            this.errorState = ErrorStates.NoError;
            this.messagesService.confirm(
              'Seven ERP',
              'Un mensaje con instrucciones de recuperación ha sido enviado'
            );

            this.router.navigate(['/login']);
          }
          else{
            this._spinnerService.close();
            this.messagesService.error(
              'Seven ERP',
              result.errorMessage
            );
          }
   
            
        });
      this.unsubscribe.push(forgotPasswordSubscr);
    }
    else{
      this._spinnerService.close();
      this.messagesService.error(
        'Seven ERP',
        'Correo inválido'
      );
    }

  }
  reloadPage() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }
  validateSpecialCharacters() {
    return (control: any) => {
      const specialChars = /[^A-Za-z0-9]/g;
      const matches = control.value.match(specialChars);
      return matches && matches.length >= 2
        ? null
        : { specialCharsRequired: true };
    };
  }

  checkPasswordConditions(password: string): void {
    this.passwordConditions.length = password.length >= this.par_nmin && password.length <= this.par_nmax;
    if(this.par_ccln=="S"){
      this.passwordConditions.specialChars = (password.match(/[^a-zA-Z0-9\s\-;]/g) || []).length >= 2;
    }
    this.passwordConditions.uppercase = /[A-Z]/.test(password);
    this.passwordConditions.numbers = (password.match(/[0-9]/g) || []).length >= 3;
  
    // Validación de contraseñas previas (simulada aquí)
    const previousPasswords = ['OldPass1!', 'OldPass2@', 'OldPass3#', 'OldPass4$'];
    this.passwordConditions.notRepeated = !previousPasswords.includes(password);
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
